import moment from "moment-timezone";
import "moment/locale/he"; // without this line, language is not imported
// material
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {
  IconButton,
  DialogTitle,
  DialogContent,
  Button,
  InputLabel,
  Box,
  Select,
  MenuItem,
  TextField,
  FormControl,
  Typography,
  Divider,
  Stack,
  Grid
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
// components
import "moment/locale/he"; // without this line, language is not imported
import { useState, useEffect } from "react";
// hooks
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import { useSnackbar } from "notistack5";
import { useForm, Controller } from "react-hook-form";
import useFirestore from "../../../hooks/useFirestore";
import { PhoneNumberCellRenderer } from "utils/Haim/agGridCellRenderers";
import { parsePhoneNumber } from "utils/Haim/phoneNumbersUtils";
import { PhoneNumber } from "libphonenumber-js/types";
import { CallTranscriptAndSummary } from "./../../../@types/sharedSchema";
import { useTranslation } from "react-i18next";
import Label, { getLabelColorForString } from "components/Label";
import { formatShortCurrency } from "utils/Haim/utils";

type Props = DialogProps & {
  callTranscriptAndSummary: CallTranscriptAndSummary;
};

function TranscriptionDialog({ open, callTranscriptAndSummary, ...props }: Props) {
  const [modalOpen, setModalOpen] = useState(open);
  const { t } = useTranslation();

  const handleClose = () => {
    setModalOpen(false);
  };

  const showSplitTranscription = callTranscriptAndSummary.splitTranscription?.length > 2;
  const showTextTranscription =
    !showSplitTranscription &&
    callTranscriptAndSummary.textTranscription &&
    callTranscriptAndSummary.textTranscription.length > 100;
  return (
    <Dialog
      {...props}
      maxWidth="lg"
      fullWidth={true}
      open={modalOpen}
      onBackdropClick={handleClose}
      onClose={handleClose}
    >
      <DialogTitle sx={{ p: 1 }}>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="h4">סיכום</Typography>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {callTranscriptAndSummary.AI?.callSummary}
          </Typography>
        </Stack>

        <Divider sx={{ pb: 3 }} />

        <Stack spacing={1}>
          <Typography variant="h4">מידע שנאסף על הלקוח</Typography>
          <Stack spacing={1}>
            <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
              {callTranscriptAndSummary.AI?.customerSummary}
            </Typography>

            <Grid container>
              {callTranscriptAndSummary.AI?.customerDetails &&
                Object.keys(callTranscriptAndSummary.AI?.customerDetails).length > 0 &&
                Object.entries(callTranscriptAndSummary.AI?.customerDetails)
                  .filter(([key, value]) => value)
                  .filter(([key, value]) => key !== "interestedInLocations") // filtering locations for now, will add later
                  .sort((a, b) => (a[0] > b[0] ? -1 : 0))
                  .map(([key, value]) => {
                    const labelColor = getLabelColorForString(key);
                    const parssedValue =
                      key === "customerBudget" ? formatShortCurrency(value as number) : value;
                    return (
                      <Grid item xs={6} sm="auto" p={2}>
                        <Stack direction="row" spacing={1}>
                          <Label color={labelColor}>
                            {`${t(`contactsPage.tableColumns.${key}`) ?? key}: ${parssedValue}`}
                          </Label>
                        </Stack>
                      </Grid>
                    );
                  })}
            </Grid>
          </Stack>
        </Stack>

        <Divider sx={{ pb: 3 }} />

        {(showSplitTranscription || showTextTranscription) && (
          <Stack spacing={2}>
            <Typography variant="h4" sx={{ pb: 1 }}>
              תמלול
            </Typography>

            {showSplitTranscription &&
              callTranscriptAndSummary.splitTranscription.map((t) => {
                let labelColor = getLabelColorForString(t.speaker);
                return (
                  <Box>
                    <Label color={labelColor}>{t.speaker}</Label>
                    <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
                      {t.sentence}
                    </Typography>
                  </Box>
                );
              })}
            {showTextTranscription && (
              <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
                {callTranscriptAndSummary.textTranscription?.split(/(?<=[.!?])/g).join("\n")}
              </Typography>
            )}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default TranscriptionDialog;
